import styled from "styled-components";
import {IInputStyled} from "@/components/Input/types";

export const InputStyled = styled.div<IInputStyled>`
  position: relative;

  .icon {
    display: block !important;

    &:before {
      transform: rotate(-90deg);
      transition: transform 0.35s cubic-bezier(0.65, 0.05, 0.36, 1);
    }
  }

  .icon:before {
    content: "";
    position: absolute;
    right: 16px;
    top: 34%;
    width: 13px;
    height: 13px;
    margin-right: 0.5em;
    display: inline-block;
    border-right: 1px solid ${({iconColor}) => (iconColor ? iconColor : "#e60000")};
    border-top: 1px solid ${({iconColor}) => (iconColor ? iconColor : "#e60000")};
    transform: rotate(135deg);
  }

  label {
    font-size: 20px;
    line-height: 1.4;
    color: ${({textColor}) => (textColor ? textColor : "#666")};
    position: absolute;
    pointer-events: none;
    left: 15px;
    top: 17px;
    padding: 0 5px;
    background: #fff;
    transition: 0.2s ease all;
    -moz-transition: 0.2s ease all;
    -webkit-transition: 0.2s ease all;
    @media screen and (max-width: 480px) {
      font-size: 18px;
      line-height: 1.33;
      top: 13px;
    }
  }

  input {
    height: 60px;
    width: 100%;
    padding: 16.4px 56px 15.6px 16px;
    border-radius: 6px;
    border: ${({bordersizes}) => (bordersizes ? bordersizes : "1")}px solid ${({borderColor}) => (borderColor ? borderColor : "#666")};
    background-color: #fff;
    font-size: 20px;
    line-height: 1.4;
    color: ${({textColor}) => (textColor ? textColor : "#666")};

    &:focus {
      outline: none;

      ~ .text-label {
        top: -8px;
        font-size: 14px;
      }
    }

    &:hover {
      cursor: ${({readOnly}) => (readOnly ? "pointer" : "auto")};
    }

    &:disabled {
      color: #999999;
      border: 1px solid #999999 !important;

      & ~ label {
        color: #999999 !important;
      }
    }

    @media screen and (max-width: 480px) {
      height: 48px;
      padding: 12px 48px 12px 14px;
      font-size: 18px;
      line-height: 1.33;
      color: ${({textColor}) => (textColor ? textColor : "#333")};
    }
  }

  span {
    display: none;
  }

  .text-input:not(:placeholder-shown) ~ span {
    display: block;
    width: 24px;
    height: 24px;
    font-size: 24px;
    position: absolute;
    right: 0;
    top: 18px;
    text-align: right;
    margin-right: 16px;

    &:hover {
      cursor: pointer;
    }

    @media screen and (max-width: 480px) {
      top: 14px;
    }
  }

  .text-input:not(:placeholder-shown) ~ .text-label {
    top: -8px;
    font-size: 14px;
    line-height: 1.29;
    color: ${({borderValue}) => (borderValue ? borderValue : "#007c92")};
  }

  .text-input:not(:placeholder-shown) {
    padding: 16px;
    border: 1px solid ${({borderValue}) => (borderValue ? borderValue : "#007c92")};
    background-color: #fff;
  }

  &.error-input {
    .text-input {
      border: 1px solid #e60000;
      color: #333;
    }

    .text-label {
      color: #e60000 !important;
    }
  }
`;
